import { isDeletingAtom } from '@activities/myMenu/MyMenuActivity/atoms/myMenuAtoms';
import BottomSheetHeader from '@components/BottomSheetHeader';
import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useSetAtom } from 'jotai';

declare module '@stackflow/config' {
    interface Register {
        MyMenuSettingBottomSheet: {};
    }
}

const MyMenuSettingBottomSheet: ActivityComponentType<'MyMenuSettingBottomSheet'> = () => {
    const { pop, replace } = useFlow();
    const setDeleting = useSetAtom(isDeletingAtom);
    const handleDeleteAll = () => {
        replace('DeleteAllMyMenuModal', {});
    };
    const handleStartDelete = () => {
        setDeleting(true);
        pop();
    };
    return (
        <BottomSheet>
            <BottomSheetHeader>
                MY메뉴 설정
            </BottomSheetHeader>
            <Container>
                <MainText fontWeight='bold' size='title'>
                    메인화면 노출
                </MainText>
                <Checkbox>전체 숨기기</Checkbox>
                <NoteBox>
                    <Text color={colors.gray6}>
                        메뉴를 삭제 하지 않고 일시적으로 숨겨서 전체 리스트를 미노출시킬 수 있습니다.
                    </Text>
                </NoteBox>
                <Text fontWeight='bold' size='title'>
                    메뉴 삭제
                </Text>
                <Remove spacing={3}>
                    <Text onClick={handleStartDelete}>선택 삭제</Text>
                    <Text onClick={handleDeleteAll}>
                        전체 삭제
                    </Text>
                </Remove>
            </Container>
        </BottomSheet>
    );
};

const Container = styled(Column)`
    padding: 24px 20px calc(16px + var(--safe-area-bottom));
`;

const MainText = styled(Text)`
    margin-bottom: 16px;
`;

const NoteBox = styled.div`
    background-color: var(--color-gray2);
    border-radius: 8px;
    margin: 8px 0 24px;
    padding: 12px;
`;

const Remove = styled(Column)`
    margin-top: 16px;
`;

export default MyMenuSettingBottomSheet;
